module.exports = __webpack_public_path__ + "img/Support-skill-518.9c81ebde.png";